import React, { useEffect, useState } from 'react';
import './CardComponent.css';
import cardBack from './assets/card-back.png';
import jokerCard from './assets/joker-card.png';

function CardComponent({ card }) {
  const [flipped, setFlipped] = useState(false);

  useEffect(() => {
    setFlipped(false);
    const timer = setTimeout(() => setFlipped(true), 600);
    return () => clearTimeout(timer);
  }, [card]);

  const suitSymbol = {
    Hearts: '♥',
    Diamonds: '♦',
    Spades: '♠',
    Clubs: '♣',
  }[card.suit];

  const isRed = card.suit === 'Hearts' || card.suit === 'Diamonds';

  const convertValue = (value) => {
    const faceMap = {
      11: 'J',
      12: 'Q',
      13: 'K',
      14: 'A',
      15: '🂿',
    };
    return faceMap[value] || value;
  };

  const getExerciseDisplay = (value, exercise) => {
    const valueMap = {
      J: 11,
      Q: 12,
      K: 13,
      A: 14,
      '🂿': 15
    };
    const displayValue = convertValue(value);
    const numericValue = valueMap[displayValue] || value;
    return `${numericValue} ${exercise}`;
  };

  const isJoker = card.suit === 'Joker';

  return (
    <div className="card-scene">
      <div className={`card-container ${flipped ? 'flipped' : ''}`}>
        {/* Back Face */}
        <div className="card-face card-back">
          <img src={cardBack} alt="Card Back" className="card-back-image" />
        </div>

        {/* Front Face */}
        <div className="card-face card-front">
          {isJoker ? (
            <img src={jokerCard} alt="Joker Card" className="card-joker-image" />
          ) : (
            <>
              <div className="card-corner top-left" style={{ color: isRed ? 'red' : 'black', fontSize: '1.5rem' }}>
                {convertValue(card.value)}
                <br />
                {suitSymbol}
              </div>
              <div className="card-center">{getExerciseDisplay(card.value, card.exercise)}</div>
              <div className="card-corner bottom-right" style={{ color: isRed ? 'red' : 'black', fontSize: '1.5rem' }}>
                {convertValue(card.value)}
                <br />
                {suitSymbol}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default CardComponent;
